export default "__VITE_PUBLIC_ASSET__a3adffd3__"